import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache: true
};
const noCacheMeta = {
    auth: false
};

export default {
    path: '/sclm',
    name: 'sclm',
    meta,
    component: BasicLayout,
    children: [
        //============================================demo start=====================================================
        {
            path: '/sclm/sclmDemoList2',
            name: 'sclmDemoList',
            meta: {
                ...meta,
                title: 'demo',
                desc: 'demo'
            },
            component: () => import('@/pages/sclm/demo/sclmDemoList.vue')
        },
        {
            path: '/sclm/sclmDemoList',
            name: 'officeDemo',
            meta: {
                ...meta,
                title: 'officeDemo',
                desc: '在线office编辑demo'
            },
            component: () => import('@/pages/sclm/demo/sclmOfficeDemo.vue')
        },
        {
            path: '/sclm/dataImport',
            name: 'dataImport',
            meta: {
                ...noCacheMeta,
                title: 'dataImport',
                desc: 'dataImport'
            },
            component: () => import('@/pages/demo/DataImprot.vue')
        },
        //============================================demo end=====================================================

        //============================================主数据 start=====================================================
        {
            path: '/master/sclmMSealList',
            name: 'sclmMSealList',
            meta: {
                ...meta,
                title: '$t:menu.sclmMSealList',
                desc: '印章一览'
            },
            component: () => import('@/pages/sclm/master/sclmMSealList.vue')
        },
        {
            path: '/supplierManage/sclmMContractPartyList',
            name: 'sclmMContractPartyList',
            meta: {
                ...meta,
                title: '$t:menu.sclmMContractPartyList',
                desc: '供应商'
            },
            component: () => import('@/pages/sclm/master/sclmMContractPartyList.vue')
        },
        {
            path: '/master/sclmMCompanyList',
            name: 'sclmMCompanyList',
            meta: {
                ...meta,
                title: '$t:menu.sclmMCompanyList',
                desc: '公司'
            },
            component: () => import('@/pages/sclm/master/sclmMCompanyList.vue')
        },
        {
            path: '/master/sclmMContractTemplate',
            name: 'sclmMContractTemplate',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.sclmMContractTemplate',
                desc: '合同类型模板管理'
            },
            component: () => import('@/pages/sclm/master/sclmMContractTemplate.vue')
        },
       
        {
            path: '/master/labelList',
            name: 'labelList',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.labelList',
                desc: '标签一览'
            },
            component: () => import('@/pages/sclm/master/labelList.vue')
        },
        //============================================主数据 end=====================================================

        //============================================ 业务start=====================================================
        //文件对比
        {
            path: '/ocr/ocrFileDiff',
            name: 'ocrFileDiff',
            meta: {
                ...meta,
                title: '$t:menu.ocrFileDiff',
                desc: '合同对比'
            },
            component: () => import('@/pages/sclm/ocr/ocrFileDiff.vue')
        },
        {
            path: '/ocr/ocrGetImgContent',
            name: 'ocrGetImgContent',
            meta: {
                ...meta,
                title: 'OCR识别',
                desc: 'OCR识别'
            },
            component: () => import('@/pages/sclm/ocr/ocrGetImgContent.vue')
        },
        {
            path: '/chatGpt',
            name: 'chatGpt',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.chatGptMenu',
                desc: 'AI法务助理'
            },
            component: () => import('@/pages/sclm/chatGpt/chatGpt.vue')
        },
        {
            path: '/chatGpt2',
            name: 'chatGpt2',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.chatGptMenu',
                desc: 'AI法务助理'
            },
            component: () => import('@/pages/sclm/chatGpt/chatGpt2.vue')
        },
        {
            path: '/contract/contractExtractData',
            name: 'contractExtractData',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.contractExtractData',
                desc: '合同元素提取'
            },
            component: () => import('@/pages/sclm/contract/contractExtractData.vue')
        },
        {
            path: '/contract/fileTranslation',
            name: 'fileTranslation',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.fileTranslation',
                desc: '合同翻译'
            },
            component: () => import('@/pages/sclm/contract/fileTranslation.vue')
        },
        {
            path: '/contract/sclmTApplyContractList',
            name: 'sclmTApplyContractList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTApplyContractList',
                desc: '合同一览'
            },
            component: () => import('@/pages/sclm/contract/sclmTApplyContractList.vue')
        },
        {
            path: '/contract/sclmTApplyContractListQys',
            name: 'sclmTApplyContractListQys',
            meta: {
                ...meta,
                title: '$t:menu.sclmTApplyContractList',
                desc: '合同一览'
            },
            component: () => import('@/pages/sclm/contract/sclmTApplyContractListQys.vue')
        },
        {
            path: '/contract/sclmTContractFilingList',
            name: 'sclmTContractFilingList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTContractFilingList',
                desc: '合同归档一览'
            },
            component: () => import('@/pages/sclm/contractFiling/sclmTContractFilingList.vue')
        },
        {
            path: '/contractFiling/sclmContractFilingPhysics',
            name: 'sclmContractFilingPhysics',
            meta: {
                ...meta,
                title: '$t:menu.sclmContractFilingPhysics',
                desc: '合同物理章归档'
            },
            component: () => import('@/pages/sclm/contractFiling/sclmContractFilingPhysics.vue')
        },
        {
            path: '/contract/sclmTContractSignList',
            name: 'sclmTContractSignList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTContractSignList',
                desc: '合同签署'
            },
            component: () => import('@/pages/sclm/contract/sclmTContractSignList.vue')
        },
        {
            path: '/contract/sclmTContractOverview',
            name: 'sclmTContractOverview',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.sclmTContractOverview',
                desc: '合同全景'
            },
            component: () => import('@/pages/sclm/contract/sclmTContractOverview.vue')
        },
        {
            path: '/contract/sclmTDisputeReportingList',
            name: 'sclmTDisputeReportingList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTDisputeReportingList',
                desc: '纠纷上报'
            },
            component: () => import('@/pages/sclm/contract/sclmTDisputeReportingList.vue')
        },
        {
            path: '/contract/contractSearch',
            name: 'contractSearch',
            meta: {
                ...meta,
                title: '$t:menu.contractSearch',
                desc: '合同搜索'
            },
            component: () => import('@/pages/sclm/contract/contractSearch.vue')
        },
        {
            path: '/contract/depositManageList',
            name: 'depositManageList',
            meta: {
                ...meta,
                title: '$t:menu.depositManageList',
                desc: '押金管理'
            },
            component: () => import('@/pages/sclm/contract/depositManageList.vue')
        },

        //==================采购合同 start======================
        {
            path: '/purchContract/purchaseApplyList',
            name: 'purchaseApplyList',
            meta: {
                ...meta,
                title: '$t:menu.purchaseApplyList',
                desc: '接收'
            },
            component: () => import('@/pages/sclm/purchContract/purchaseApplyList.vue')
        },
        {
            path: '/purchContract/receiveList',
            name: 'receiveList',
            meta: {
                ...meta,
                title: '$t:menu.receiveProcure',
                desc: '接收'
            },
            component: () => import('@/pages/sclm/purchContract/receiveList.vue')
        },
        {
            path: '/purchContract/receiveDetail',
            name: 'receiveDetail',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.receiveProcure',
                desc: '接收详情'
            },
            component: () => import('@/pages/sclm/purchContract/receiveDetail.vue')
        },
        {
            path: '/purchContract/inspectionList',
            name: 'inspectionList',
            meta: {
                ...meta,
                title: '$t:menu.checkAcceptProcure',
                desc: '验收'
            },
            component: () => import('@/pages/sclm/purchContract/inspectionList.vue')
        },
        {
            path: '/purchContract/cancelList',
            name: 'cancelList',
            meta: {
                ...meta,
                title: '$t:menu.returnGoods',
                desc: '退货'
            },
            component: () => import('@/pages/sclm/purchContract/cancelList.vue')
        },
        {
            path: '/purchContract/cancelDetail',
            name: 'cancelDetail',
            meta: {
                ...meta,
                title: '$t:menu.returnGoods',
                desc: '退货详情'
            },
            component: () => import('@/pages/sclm/purchContract/cancelDetail.vue')
        },
        {
            path: '/purchContract/invoiceList',
            name: 'invoiceList',
            meta: {
                ...meta,
                title: '$t:menu.invoiceProcure',
                desc: '发票'
            },
            component: () => import('@/pages/sclm/purchContract/invoiceList.vue')
        },
        {
            path: '/purchContract/invoiceDetailList',
            name: 'invoiceDetailList',
            meta: {
                ...noCacheMeta,
                title: '发票一览',
                desc: '发票明细一览'
            },
            component: () => import('@/pages/sclm/purchContract/invoiceDetailList.vue')
        },
        {
            path: '/purchContract/payList',
            name: 'payList',
            meta: {
                ...meta,
                title: '$t:menu.payment',
                desc: '付款'
            },
            component: () => import('@/pages/sclm/purchContract/payList.vue')
        },
        {
            path: '/purchContract/inquiryList',
            name: 'inquiryList',
            meta: {
                ...meta,
                title: '$t:menu.inquiry',
                desc: '询价'
            },
            component: () => import('@/pages/sclm/purchContract/inquiryList.vue')
        },
        {
            path: '/purchContract/itemList',
            name: 'item',
            meta: {
                ...meta,
                title: '$t:menu.item',
                desc: '品目'
            },
            component: () => import('@/pages/sclm/purchContract/itemList.vue')
        },
        //==================采购合同 end======================


        //==================采购合同 end======================

        //==================仓库 start======================
        {
            path: '/warehouse/sclmTWarehouseList',
            name: 'sclmTWarehouseList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTWarehouseList',
                desc: '仓库维护'
            },
            component: () => import('@/pages/sclm/warehouse/sclmTWarehouseList.vue')
        },
        {
            path: '/warehouse/sclmTWarehousePutList',
            name: 'sclmTWarehousePutList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTWarehousePutList',
                desc: '入库入力'
            },
            component: () => import('@/pages/sclm/warehouse/sclmTWarehousePutList.vue')
        },
        {
            path: '/warehouse/warehouseManageList',
            name: 'warehouseManageList',
            meta: {
                ...meta,
                title: '$t:menu.warehouseManageList',
                desc: '在库管理'
            },
            component: () => import('@/pages/sclm/warehouse/warehouseManageList.vue')
        },
        {
            path: '/warehouse/warehouseStockRemoval',
            name: 'warehouseStockRemoval',
            meta: {
                ...meta,
                title: '$t:menu.warehouseStockRemoval',
                desc: '出库一览'
            },
            component: () => import('@/pages/sclm/warehouse/warehouseStockRemoval.vue')
        },
        {
            path: '/warehouse/materialList',
            name: 'materialList',
            meta: {
                ...meta,
                title: '$t:menu.materialList',
                desc: '物料一览'
            },
            component: () => import('@/pages/sclm/warehouse/materialList.vue')
        },

        //==================仓库 end======================


        //==================销售合同 start======================
        {
            path: '/saleContract/quotationList',
            name: 'quotationList',
            meta: {
                ...meta,
                title: '$t:menu.quotationList',
                desc: '报价一览'
            },
            component: () => import('@/pages/sclm/saleContract/quotationList.vue')
        },
        {
            path: '/saleContract/productList',
            name: 'productList',
            meta: {
                ...meta,
                title: '$t:menu.productList',
                desc: '产品一览'
            },
            component: () => import('@/pages/sclm/saleContract/productList.vue')
        },
        {
            path: '/saleContract/productDetail',
            name: 'productDetail',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.productProcure',
                desc: '产品详情'
            },
            component: () => import('@/pages/sclm/saleContract/productDetail.vue')
        },
        {
            path: '/saleContract/sclmTNicheList',
            name: 'sclmTNicheList',
            meta: {
                ...meta,
                title: '$t:menu.sclmTNicheList',
                desc: '商机一览'
            },
            component: () => import('@/pages/sclm/saleContract/sclmTNicheList.vue')
        },
        {
            path: '/saleContract/orderList',
            name: 'orderList',
            meta: {
                ...meta,
                title: '$t:menu.orderList',
                desc: '订单'
            },
            component: () => import('@/pages/sclm/saleContract/orderList.vue')
        },
        {
            path: '/saleContract/deliveryList',
            name: 'deliveryList',
            meta: {
                ...meta,
                title: '$t:menu.deliveryList',
                desc: '发货一览'
            },
            component: () => import('@/pages/sclm/saleContract/deliveryList.vue')
        },
        {
            path: '/saleContract/deliveryDetail',
            name: 'deliveryDetail',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.deliveryProcure',
                desc: '发货'
            },
            component: () => import('@/pages/sclm/saleContract/deliveryDetail.vue')
        },
        {
            path: '/saleContract/inspectionList',
            name: 'saleInspectionList',
            meta: {
                ...meta,
                title: '$t:menu.checkAcceptSale',
                desc: '验收'
            },
            component: () => import('@/pages/sclm/saleContract/inspectionList.vue')
        },
        {
            path: '/saleContract/cancelList',
            name: 'saleCancelList',
            meta: {
                ...meta,
                title: '$t:menu.returnGoods',
                desc: '退货'
            },
            component: () => import('@/pages/sclm/saleContract/cancelList.vue')
        },
        {
            path: '/saleContract/cancelDetail',
            name: 'saleCancelDetail',
            meta: {
                ...meta,
                title: '$t:menu.returnGoods',
                desc: '退货详情'
            },
            component: () => import('@/pages/sclm/saleContract/cancelDetail.vue')
        },
        {
            path: '/saleContract/changeDetail',
            name: 'saleChangeDetail',
            meta: {
                ...meta,
                title: '$t:menu.changeGoods',
                desc: '换货详情'
            },
            component: () => import('@/pages/sclm/saleContract/changeDetail.vue')
        },
        {
            path: '/saleContract/saleInvoiceList',
            name: 'saleInvoiceList',
            meta: {
                ...meta,
                title: '$t:menu.invoiceProcure',
                desc: '发票'
            },
            component: () => import('@/pages/sclm/saleContract/saleInvoiceList.vue')
        },
        {
            path: '/saleContract/saleInvoiceDetailList',
            name: 'saleInvoiceDetailList',
            meta: {
                ...noCacheMeta,
                title: '发票一览',
                desc: '发票明细一览'
            },
            component: () => import('@/pages/sclm/saleContract/saleInvoiceDetailList.vue')
        },
        {
            path: '/saleContract/collectionList',
            name: 'collectionList',
            meta: {
                ...meta,
                title: '$t:menu.collection',
                desc: '收款'
            },
            component: () => import('@/pages/sclm/saleContract/collectionList.vue')
        },
        //==================销售合同 end======================

        //============================================业务 end=====================================================
        {
            path: '/signingPartyDocuments/sclmSigningPartyDocumentsList',
            name: 'SigningPartyDocumentsList',
            meta: {
                ...meta,
                title: '$t:menu.qyfxcpg',
                desc: '签约方现场评审模板维护'
            },
            component: () => import('@/pages/sclm/master/SigningPartyDocumentsList.vue')
        },
      
        {
            path: '/signingPartyDocuments/SingingPartySupplier',
            name: 'SingingPartySupplier',
            meta: {
                ...meta,
                title: '$t:menu.qyfzr',
                desc: '签约方准入'
            },
            component: () => import('@/pages/sclm/master/SingingPartySupplier.vue')
        },
        {
            path: '/signingPartyDocuments/SigningPartiesContractingList',
            name: 'SigningPartiesContractingList',
            meta: {
                ...meta,
                title: '$t:menu.qyfkpjh',
                desc: '签约方考评计划'
            },
            component: () => import('@/pages/sclm/master/SigningPartiesContractingList.vue')
        },{
            path: '/signingPartyDocuments/SigningPerformanceList',
            name: 'SigningPerformanceList',
            meta: {
                ...meta,
                title: '$t:menu.qyfjxkp',
                desc: '签约方绩效考评'
            },
            component: () => import('@/pages/sclm/master/SigningPerformanceList.vue')
        },
        {
            path: '/signingPartyDocuments/SigningClassificationList',
            name: 'SigningClassificationList',
            meta: {
                ...meta,
                title: '$t:menu.qyffj',
                desc: '签约方退出'
            },
            component: () => import('@/pages/sclm/master/SigningClassificationList.vue')
        },{
            path: '/signingPartyDocuments/SigningSourcingList',
            name: 'SigningSourcingList',
            meta: {
                ...meta,
                title: '$t:menu.gysxy',
                desc: '供应商寻源'
            },
            component: () => import('@/pages/sclm/master/SigningSourcingList.vue')
        },{
            path: '/signingPartyDocuments/sclmMSupplierTemplate',
            name: 'sclmMSupplierTemplate',
            meta: {
                ...meta,
                title: '$t:menu.gysxcpsmbwh',
                desc: '供应商现场评审模板维护'
            },
            component: () => import('@/pages/sclm/master/sclmMSupplierTemplate.vue')
        },{
            path: '/signingPartyDocuments/SigningPartiesMasterList',
            name: 'SigningPartiesMasterList',
            meta: {
                ...meta,
                title: '$t:menu.gysccpj',
                desc: '供应商初次评级Master'
            },
            component: () => import('@/pages/sclm/master/SigningPartiesMasterList.vue')
        },
     
        {
            path: '/signingPartyDocuments/SclmMSupplierRiskTypeList',
            name: 'SclmMSupplierRiskTypeList',
            meta: {
                ...noCacheMeta,
                title: '$t:menu.SclmMSupplierRiskTypeList',
                desc: '供应商风险类型配置'
            },
            component: () => import('@/pages/sclm/master/SclmMSupplierRiskTypeList.vue')
        },
        // {
        //     path: '/signingPartyDocuments/sclmMContractPartyEdit',
        //     name: 'sclmMContractPartyEdit',
        //     meta: {
        //         ...meta,
        //         title: '$t:menu.SclmMSupplierRiskTypeList',
        //         desc: '测试页面'
        //     },
        //     component: () => import('@/pages/sclm/master/test.vue')
        // },
     

    ]
};
